window.custom_bundle_tracker = {};
let allLoopBundleData = [];
const LOOP_BUNDLE_URL = "https://api-service.loopwork.co/bundleTransaction/getBundleCartDetails";

const getItemKeysByBundleIdLoop = (bundleId, cartItems) => {
  const data = {
      updates: {},
  };
  for (const item of cartItems) {
      const _bundleId =
          item?.properties?._bundleId ?? item?.properties?.bundleId;
      if (!_bundleId || _bundleId !== bundleId) continue;
      data.updates[item.key] = 0;
  }
  return data;
};

// removes a bundleId from cart
const removeBundleLoop = async (bundleId, cartItems) => {
  const data = getItemKeysByBundleIdLoop(bundleId, cartItems);
  const endpoint = `${window.Shopify.routes.root}cart/update.js`;
  const resp = await fetch(endpoint, {
      method: "POST",
      headers: {
          "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
  });
  const cartData = await resp.json();
  console.debug({ cartData });

  if (window.location.pathname.split('/').pop() === 'cart') {
    window.location.reload(); return;
  }

  document.dispatchEvent(
    new CustomEvent('theme:cart:change', {
      detail: {
        cart: cartData,
      },
      bubbles: true,
    })
  );

  document.querySelector('[data-drawer="drawer-cart"]')?.dispatchEvent(
    new CustomEvent('theme:drawer:open', {
      bubbles: false,
    })
  );

  if (cartData && cartData.item_count === 0) {
    if (document.getElementById('cart-rewards-bar-background-wrapper')) {
      document.getElementById('cart-rewards-bar-background-wrapper').classList.add('empty-cart-progress');
    }
  }
  // window.location.href = window.location.href;
};


const fetchBundleTransactionCartDetails = async (loopBundleGuid) => {
  const _endpoint = `${LOOP_BUNDLE_URL}/${loopBundleGuid}`;
  const _response = await fetch(_endpoint);
  return await _response.json();
};

const fixBundleImagesAndLinks = async (bundleObjects, cart) => {
  // console.log("fixBundleImagesAndLinks:start");
  let loopBundleIds = [];
  for (const bundleId in bundleObjects) {
    if (bundleObjects[bundleId]?.[0].properties?._bundleRef) {
      loopBundleIds.push(bundleObjects[bundleId]?.[0].properties._bundleRef);
    }
  }

  // const promises = loopBundleIds.map(async (bundleId) => {
  //   return fetch(`https://apiv2.loopwork.co/bundleStorefront/${bundleId}`).then((res) => res.json());
  // })

  const bundleTransactionIds = Object.keys(bundleObjects);
  const promises2 = bundleTransactionIds.map(async (bundleId) => {
    return fetchBundleTransactionCartDetails(bundleId);
  });

  const allBundleTransactions = await Promise.all(promises2);
  // console.log({ allBundleTransactions });

  // const allBundleData = await Promise.all(promises);
  // allLoopBundleData = allBundleData.map((item) => item.data?.data || item.data);

  allBundleTransactions.forEach((loopBundleTransactionDetail, index) => {
    const loopBundleId = loopBundleTransactionDetail.loopBundleId;
    const bundleElem = document.querySelector(`.cart__items__row[data-bundle-id="${bundleTransactionIds[index]}"]`);
    if (bundleElem) {
      const imageElemToUpdate = bundleElem.querySelector('img');
      if (imageElemToUpdate) {
        const bundle_preset_image_src = bundleElem.querySelector('a.custom-cart-item-name')?.getAttribute('data-bundle_preset_image_src');
        imageElemToUpdate.src = bundle_preset_image_src || loopBundleTransactionDetail?.image;
      }
      // const _isPresetBundleProduct = bundleObjects[bundleTransactionIds[index]][0].properties?.['_isPresetBundleProduct'];

      let bundleEditPage = `/pages/family-circle?bid=${bundleTransactionIds[index]}`;
      if (loopBundleTransactionDetail.product_handle) {
        bundleEditPage = `/products/${loopBundleTransactionDetail.product_handle}`;
      }
      const bundleTitleElem = bundleElem.querySelector('.cart__items__title a');
      // console.log({ bundleTitleElem });
      if (bundleTitleElem) {
          bundleTitleElem.href = bundleEditPage;
      }
      const itemImageLink = bundleElem.querySelector('.cart__items__image a');
      if (itemImageLink) {
          itemImageLink.href = bundleEditPage;
      }

    }
  });

  // console.log({ allBundleData, allLoopBundleData, bundleObjects });
}

function renderBundleItemsV2(cart, timestamp = 1) {
  console.debug('renderBundleItemsV2', cart, timestamp);

//   const cartRewardBar = document.getElementById('cart-rewards-bar-background-wrapper');
//   console.debug({ cartRewardBar });
//   if (cartRewardBar) {
//       if (cart?.items?.length) {
//         cartRewardBar.classList.remove('empty-cart-progress');
//       } else {
//         cartRewardBar.classList.add('empty-cart-progress');
//       }
//   }

  if (custom_bundle_tracker[timestamp]) {
    console.debug(`renderBundleItemsV2 already called with ${timestamp}`);
    // return;
  }

  const bundleObjects = {};

  for (const item of cart.items) {
    if (item.properties?.bundleName && item.properties?._bundleId) {
      bundleObjects[item.properties._bundleId] = bundleObjects[item.properties._bundleId] || [];
      bundleObjects[item.properties._bundleId].push(item);
    }
  }

  console.debug({ bundleObjects });

  fixBundleImagesAndLinks(bundleObjects, cart);

  for (const bundleId in bundleObjects) {
    const items = bundleObjects[bundleId];
    const bundleElem = document.querySelector(`.cart__items__row.is-bundle-item[data-bundle-id="${bundleId}"]`);
    console.debug({ bundleElem });

    if (!bundleElem) continue;

    // function execution shouldn't be allowed for the caller that uses the same timestamp again
    custom_bundle_tracker[timestamp] = true;

    const _isPresetBundleProduct = items[0].properties?.['_isPresetBundleProduct'];

    // update image
    // const bundleImage = bundleElem.querySelector('.cart__items__image img');
    // if (bundleImage) {
    //   if (_isPresetBundleProduct) {
    //     bundleImage.src = 'https://maelove.com/cdn/shop/files/bestseller_duo_carousel_1.jpg?v=1728357014&width=1200';
    //   } else {
    //     bundleImage.src = 'https://s3.amazonaws.com/production.assets/bundle-images%2F47f694444e49d75ed68f4ddc23730d22-family_circle_icon_2.jpg';
    //   }
    //   bundleImage.srcset = '';
    // }

    // update meta info
    let itemsHtml = '';
    let lineTotalPrice = 0;
    let discountedPrice = 0;
    let freeItem;
    let totalAppliedDiscount = 0;
    let discountTitle = '';
    let dicountPercentage = 0;
    for (const item of items) {
      lineTotalPrice += item.original_price * item.quantity;
      discountedPrice += item.final_price * item.quantity;
      if (item.final_price === 0) {
        freeItem = item;
      }
      if (Array.isArray(item.discounts) && item.discounts.length) {
        totalAppliedDiscount += item.discounts.reduce(
          (acc, discount) => acc + discount.amount, 0);
        discountTitle = item.discounts[0].title;
      }
      if (Array.isArray(item.line_level_discount_allocations) && item.line_level_discount_allocations.length && item.line_level_discount_allocations[0].discount_application && item.line_level_discount_allocations[0].discount_application.value_type === "percentage") {
        if (Number(item.line_level_discount_allocations[0].discount_application.value) === 100) {
          // this is for the free item
        } else {
          dicountPercentage = item.line_level_discount_allocations[0].discount_application.value;
        }
      }
      let title = item.title;
      let allowedCharLength = item.final_price === 0 ? 28 : 32;
      if (window.screen.width <= 480) {
        allowedCharLength -= 7;
      }
      if (title.length > allowedCharLength) {
        title = title.substring(0, allowedCharLength).trim().concat('...');
      }
      itemsHtml += ` <p class="${item.final_price === 0 ? "loop-bundle-free-product": ""}"><span style="display:block;" class="body-size-3">${title} ${item.final_price === 0 ? ' (Free) ': ''}x ${item.quantity}</span></p>`
    }

    let bundlePresetHtml = '';
    const bundleTitleElem = bundleElem.querySelector('a.custom-cart-item-name');
    if (bundleTitleElem && bundleTitleElem.getAttribute('data-bundle_preset') && bundleTitleElem.getAttribute('data-bundle_name')) {
      bundlePresetHtml = `
        <span style="display: flex; gap: 5px; text-transform: none !important; align-items: center; position: relative; font-style: normal;">
          <span class="bundle-name">Family Circle bundle</span>
          <span class="custom-tooltip-container">
            <span class="custom-info-icon custom-tooltip-trigger">i</span>
            <span class="custom-tooltip-content">Family Circle is Maelove's exclusive subscription program. Save up to 20% off your bundle of 4 or more products.<br /> Add/remove/swap your bundled products and delivery schedule at any time. Gain access to exclusive skincare newsletters and events.</span>
          </span>
        </span>
      `
    }


    let finalHtml = `
        ${itemsHtml}
        <br>
        <p> ${bundlePresetHtml} <span class="data-cart-item-selling-plan-name">${items[0].selling_plan_allocation?.selling_plan?.name || ''}</span></p>
    `;

    const metaInfo = bundleElem.querySelector('.cart__items__meta');
    console.debug({ metaInfo });
    if (metaInfo) {
      metaInfo.innerHTML = finalHtml;
      metaInfo.style.display = 'block';
    }

    // update final price
    const cartItemPriceElem = bundleElem.querySelector('.cart__items__price');
    if (cartItemPriceElem) {
      let delTag = Number(lineTotalPrice) > Number(discountedPrice) ? `<del>${window.getCurrencySymbol()}${Number(lineTotalPrice/100).toFixed(2)}</del>` : '';
      cartItemPriceElem.innerHTML = `<p class="line__price">${delTag}<mark>${window.getCurrencySymbol()}${Number(discountedPrice/100).toFixed(2)}</mark></p>`;
    }

    // update discount tag
    const quantityBoxElem = bundleElem.querySelector('.cart__items__quantity');
    const totalSavingsElem = bundleElem.querySelector('.cart__items__savings');
    let totalAppliedDiscountAmountFormatted = parseFloat(Number(totalAppliedDiscount/100).toFixed(2));

    let discountInfo = dicountPercentage ? `You're saving ${ Math.round(dicountPercentage) }% on your bundle` : `You're saving $${totalAppliedDiscountAmountFormatted} with ${discountTitle}`;
    const totalSavingsHtml = `
        <span class="item__total__savings">
              <span class="cart__icon--tags">
                <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-tags" viewBox="0 0 14 14"><g stroke="#000" fill="none" stroke-width=".875" stroke-linecap="round" stroke-linejoin="round"><path d="M2.625.79H7l6.125 6.124m-7.8-4.374H1.75a.875.875 0 0 0-.875.874V6.99c0 .232.092.455.256.619l5.344 5.345a.875.875 0 0 0 1.438-.312l.837-2.227 2.228-.836a.875.875 0 0 0 .311-1.438L5.944 2.795a.874.874 0 0 0-.619-.256zM3.5 4.946"></path><path d="M3.5 4.946a.219.219 0 1 0 .001 0H3.5"></path></g></svg>
              </span>
              ${discountInfo}</span>
      `;
    if (totalAppliedDiscount) {
      if (totalSavingsElem) {
        totalSavingsElem.innerHTML = totalSavingsHtml;
      } else {
        if (quantityBoxElem) {
          quantityBoxElem.insertAdjacentHTML('afterend', `<div class="cart__items__savings">${totalSavingsHtml}</div>`);
        }
      }
    }

    // remove quantity box
    if (quantityBoxElem) {
      quantityBoxElem.remove();
    }

    // if the current page is the cart page, update the total column as well
    if (window.location.pathname.split('/').pop() === 'cart') {
      if (bundleElem.querySelector('.cart__items__total')) {
        bundleElem.querySelector('.cart__items__total').textContent = Number(discountedPrice/100).toFixed(2);
      }
    }

    // add remove bundle event
    const bundleRemoveDiv = bundleElem.querySelector('.cart__items__remove');
    if (bundleRemoveDiv) {
        const deleteItemElemCloned = bundleRemoveDiv.querySelector('a').cloneNode(true);
        console.debug({ deleteItemElemCloned });
        bundleRemoveDiv.querySelector('a').remove();
        bundleRemoveDiv.appendChild(deleteItemElemCloned);
        bundleRemoveDiv.querySelector('a').addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            removeBundleLoop(bundleId, items);
        });
    }

    // make the bundle editable
    // let bundleEditPage = `/pages/family-circle?bid=${bundleId}`;
    // if (_isPresetBundleProduct) {
    //   bundleEditPage = `/products/brighten-and-smooth-duo`;
    // }
    // const bundleTitleElem = bundleElem.querySelector('.cart__items__title a');
    // if (bundleTitleElem) {
    //     bundleTitleElem.href = bundleEditPage;
    // }
    // const itemImageLink = bundleElem.querySelector('.cart__items__image a');
    // if (itemImageLink) {
    //     itemImageLink.href = bundleEditPage;
    // }

    setTimeout(() => {
      bundleElem.classList.remove('empty-content');
    }, 300);
  }
}




/**
 * 
 * On PDP normal products change the add to cart button text to "Add subscription to cart" if subscription is selected
 */
const updateAddToCartButtonTextBasedOnPurchaseType = () => {
  const productContainer = document.querySelector(`.product__main__content`);
  if (!productContainer) {
    // console.log(`Product container not found`)
    return;
  }
  const input = productContainer.querySelector(`input[name="selling_plan"]`);

  if (!input) {
    // console.log(`Input not found`)
    return;
  }
  const addToCartButton = document.querySelector(`.product__submit__buttons button[type="submit"][name="add"] span[data-add-to-cart-text]`);
  if (!addToCartButton) {
    // console.log(`Add to cart button not found`)
    return;
  }

  const updateButtonText = (sellingPlanValue) => {
    console.log('updateButtonText:', sellingPlanValue);
    if (sellingPlanValue) {
      addToCartButton.textContent = "Add subscription to cart";
    } else {
      addToCartButton.textContent = "Add to Cart";
    }
  }

  updateButtonText(input.value);
}


const attachMutationForInputChange = () => {
  const container = document.querySelector(`.product__main__content form[action="/cart/add"]`);
  if (!container) return;

  const loopSellingPlanExists = container.querySelector(`input[name="selling_plan"]`);
  if (!loopSellingPlanExists) return;

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      console.log('mutation', mutation.type);
      if (mutation.type === 'childList' && mutation.addedNodes.length === 1 && mutation.addedNodes[0].nodeName === 'INPUT' && mutation.addedNodes[0].name === 'selling_plan') {
        const input = container.querySelector(`input[name="selling_plan"]`);
        if (input) {
          updateAddToCartButtonTextBasedOnPurchaseType();
        }
      }
    });
  });
  observer.observe(container, { childList: true, subtree: true });
  // console.log(`observer attached`, container)
}
updateAddToCartButtonTextBasedOnPurchaseType();
attachMutationForInputChange();